import { render, staticRenderFns } from "./Collaborate-with.vue?vue&type=template&id=7a385200&scoped=true"
import script from "./Collaborate-with.vue?vue&type=script&lang=js"
export * from "./Collaborate-with.vue?vue&type=script&lang=js"
import style0 from "./Collaborate-with.vue?vue&type=style&index=0&id=7a385200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a385200",
  null
  
)

export default component.exports